// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1qa6t","signatureButtonsRight":"ModalSign_signatureButtonsRight__2c61Y"};